export default __webpack_public_path__ + "static/media/laundry2-beforeB.99c97d51.jpg";